export default "__VITE_ASSET__C0YicGpD__ 584w";